var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogomangasio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 276,
    viewBox: "0 0 276 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16226_46510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2938 30.082H80.955L138.3 155.662L195.645 30.082H257.306V245.318H207.361L207.052 108.992L156.798 223.825H119.802L69.5477 108.992V245.318H19.2938V30.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.899 70.8367C198.749 70.8367 199.464 71.4803 199.464 72.3385C199.464 73.2395 198.749 73.9261 197.899 73.9261C197.05 73.9261 196.38 73.2395 196.38 72.3385C196.38 71.4803 197.05 70.8367 197.899 70.8367ZM208.716 44.8863H210.567V73.9261H208.716V44.8863ZM233.7 44.8863C241.709 44.8863 248.196 51.3488 248.196 59.3855C248.196 67.4222 241.709 73.9261 233.7 73.9261C225.691 73.9261 219.204 67.4222 219.204 59.3855C219.204 51.3488 225.691 44.8863 233.7 44.8863ZM233.7 46.7398C226.763 46.7398 221.054 52.3874 221.054 59.3856C221.054 66.3838 226.763 72.0723 233.7 72.0723C240.637 72.0723 246.345 66.3838 246.345 59.3856C246.345 52.3874 240.637 46.7398 233.7 46.7398Z",
    fill: "url(#paint0_linear_16226_46510)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16226_46510",
    x1: 222.288,
    y1: 44.8863,
    x2: 222.288,
    y2: 73.9261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E1C39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18131C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16226_46510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 238.2,
    height: 215.4,
    fill: "white",
    transform: "translate(19.2 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomangasio);
export default __webpack_public_path__ + "static/media/logo mangasio.829f7777b0b6462af4031289c2e2931b.svg";
export { ForwardRef as ReactComponent };